import { GetterTree } from 'vuex'
import { DivisionModule } from '..'
import { BBTreeviewNode } from '../../types'
import { toFilterSets } from '../../utils/filters/filters.generics'

export const getters: GetterTree<typeof DivisionModule['state'], unknown> = {
  divisionsAsTreeNodes(state): BBTreeviewNode {
    return {
      name: 'Division',
      id: 'all_divisions',
      groupingKey: 'division',
      type: 'Checkbox',
      children: [
        ...toFilterSets(state.all, division => {
          return {
            id: division._id,
            name: division.name,
            value: division._id,
            groupingKey: 'division',
            type: 'Checkbox'
          }
        }),
        {
          id: 'division_not_set',
          name: 'Not Set',
          value: null,
          groupingKey: 'division',
          type: 'Checkbox'
        }
      ]
    }
  }
}
